import React from 'react';
import '../../styles/components/Cta.css';

export default function PrimaryBtn({ name = 'Primary', onClick, icon, style }) {
    return (
        <button className="primary-btn" onClick={onClick} style={{ ...style }}>
            {icon && <span className="cta-icon">{icon}</span>}
            {name}
        </button>
    );
}
